import { db } from "../firebase";
import firebase from "firebase/compat/app";
import { notifyUser } from "./notifications";

// Sigue, deja de seguir o -si la cuenta destino tiene "cuentaPrivada"
// activado (ver ajustes de privacidad)- manda una solicitud pendiente en vez
// de seguir directo. Usado desde user.js, perfil.js y members.js para que el
// comportamiento sea el mismo sin importar desde dónde se aprieta "Seguir".
// Devuelve: 'followed' | 'unfollowed' | 'requested' | 'request_cancelled'.
export const toggleFollow = async ({
  currentUid,
  currentDisplayName,
  targetUid,
  isFollowing,
  targetIsPrivate,
  hasPendingRequest,
}) => {
  if (!currentUid || !targetUid || currentUid === targetUid) return null;

  const userFollowingRef = db.doc(`userFollowing/${currentUid}`);
  const companyFollowersRef = db.doc(`companyFollowers/${targetUid}`);

  if (isFollowing) {
    await userFollowingRef.update({ [targetUid]: firebase.firestore.FieldValue.delete() });
    await companyFollowersRef.update({ [currentUid]: firebase.firestore.FieldValue.delete() });
    return "unfollowed";
  }

  if (hasPendingRequest) {
    await db.doc(`followRequests/${targetUid}`).update({
      [currentUid]: firebase.firestore.FieldValue.delete(),
    });
    await db.doc(`userFollowRequests/${currentUid}`).update({
      [targetUid]: firebase.firestore.FieldValue.delete(),
    });
    return "request_cancelled";
  }

  const followerName = currentDisplayName || "Alguien";

  if (targetIsPrivate) {
    // Mismo dato en dos documentos-mapa (como userFollowing/companyFollowers):
    // followRequests/{targetUid} para que el dueño vea quién le pidió seguirlo,
    // userFollowRequests/{currentUid} para que quien pidió sepa a quién le
    // falta responder sin tener que leer un doc por cada cuenta listada.
    await db.doc(`followRequests/${targetUid}`).set(
      {
        [currentUid]: {
          displayName: followerName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        },
      },
      { merge: true }
    );
    await db.doc(`userFollowRequests/${currentUid}`).set(
      { [targetUid]: true },
      { merge: true }
    );
    await notifyUser({
      userId: targetUid,
      companyId: currentUid,
      category: "followers",
      type: "follow_request",
      message: `${followerName} quiere seguirte.`,
    });
    return "requested";
  }

  await userFollowingRef.set({ [targetUid]: true }, { merge: true });
  await companyFollowersRef.set({ [currentUid]: true }, { merge: true });
  await notifyUser({
    userId: targetUid,
    companyId: currentUid,
    category: "followers",
    type: "follower",
    message: `${followerName} empezó a seguirte.`,
  });
  return "followed";
};

// Acepta o rechaza una solicitud pendiente (botones en notifications.js,
// notificación tipo "follow_request"). Rechazar solo borra la solicitud.
export const respondFollowRequest = async ({ targetUid, targetDisplayName, requesterUid, accept }) => {
  if (!targetUid || !requesterUid) return;
  await db.doc(`followRequests/${targetUid}`).update({
    [requesterUid]: firebase.firestore.FieldValue.delete(),
  });
  await db.doc(`userFollowRequests/${requesterUid}`).update({
    [targetUid]: firebase.firestore.FieldValue.delete(),
  });
  if (accept) {
    await db.doc(`userFollowing/${requesterUid}`).set({ [targetUid]: true }, { merge: true });
    await db.doc(`companyFollowers/${targetUid}`).set({ [requesterUid]: true }, { merge: true });
    await notifyUser({
      userId: requesterUid,
      companyId: targetUid,
      category: "followers",
      type: "follow_accepted",
      message: `${targetDisplayName || "La cuenta"} aceptó tu solicitud para seguirla.`,
    });
  }
};
